module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#star",
      toString: function () {
        return this.url;
      }
    }